import { useEffect, useState } from 'react';

export function useActiveSection(sectionIds: string[]): string | null {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    const visible = new Map<string, number>();

    sectionIds.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              visible.set(id, entry.intersectionRatio);
            } else {
              visible.delete(id);
            }
          });
          let best: string | null = null;
          let max = 0;
          visible.forEach((ratio, sid) => {
            if (ratio > max) {
              max = ratio;
              best = sid;
            }
          });
          setActive(best);
        },
        { threshold: [0.25, 0.5, 0.75], rootMargin: '-80px 0px 0px 0px' },
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, [sectionIds]);

  return active;
}
